export interface User {
	email: string;
	firstName: string;
	lastName: string;
	roles: string[];
	licenseType?: LicenseType;
	approved: boolean;
}

export enum LicenseType {
	Test = 0,
	Compact = 1,
	Comfort = 2,
	Basic = 3,
    Exclusive = 4,
}